import React, { useCallback, useEffect, useMemo } from 'react';
import { Icon } from '@vectord/components';
import { batch, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  COURSE_PAUSE_MODAL_STAGES,
  COURSE_PAUSE_REQUEST_STATUSES,
  useFilteredCoursePauseRequests,
  selectedRequestSelector,
  setCoursePauseManageModalStage,
  setSelectedRequest,
  setSelectedSbatLecture,
  setSelectedSuperBatch,
} from 'features/courseResume';
import styles from './CoursePauseModalSuccessStage.module.scss';

function CoursePauseModalSuccessStage() {
  const { requestType } = useParams();
  const dispatch = useDispatch();
  const selectedRequest = useSelector(selectedRequestSelector);

  const { data } = useFilteredCoursePauseRequests({
    requestType,
    coursePauseStatus: COURSE_PAUSE_REQUEST_STATUSES.accepted,
  });

  const nextRequest = useMemo(() => {
    if (data?.data) {
      const coursePauseRequests = data.data;
      const currentRequestIndex = coursePauseRequests.findIndex(
        (request) => request.id === selectedRequest.id
      );
      if (currentRequestIndex + 1 < coursePauseRequests.length)
        return coursePauseRequests[currentRequestIndex + 1];
      else return null;
    }
    return null;
  }, [data.data, selectedRequest.id]);

  const handleNextRequest = useCallback(() => {
    // If next request exists then open that request in a modal
    // or close the modal
    if (nextRequest) {
      batch(() => {
        dispatch(setSelectedRequest(nextRequest));
        dispatch(setSelectedSbatLecture(null));
        dispatch(setSelectedSuperBatch(null));
        dispatch(
          setCoursePauseManageModalStage(COURSE_PAUSE_MODAL_STAGES.manage)
        );
      });
    } else {
      dispatch(
        setCoursePauseManageModalStage(COURSE_PAUSE_MODAL_STAGES.notOpen)
      );
    }
  }, [dispatch, nextRequest]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleNextRequest();
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, handleNextRequest]);

  return (
    <div className={styles.root}>
      <div className={styles.success}>
        <Icon
          name="tick-circle"
          className="h1 success bold m-b-m"
        />
        <div className="h2 bold m-b-xs">Resume Scheduled Successfully</div>
        <div className="h4">Request moved to Scheduled Requests</div>
      </div>
    </div>
  );
}

export default CoursePauseModalSuccessStage;
